import React, { Component } from "react";
//import { NavLink, Redirect } from "react-router-dom";Commented because not in use
import open_url from '../../images/open_url.svg';
import iconImg from '../../images/info_icon.svg'
//import pdf from '../../RXHacker-Pro-Introduction.Notification.pdf'
import pdf from '../../resources/pricing-sheets/NULIFESPANRX-Introduction.Notification_3-27-25.pdf';
import { userService } from "../../_services";
import W9FormStarter from "./W9FormStarter";

class Payments_Summary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IsnullPQKey: false,
            PQInKey: '',
            isInitiatingPayment: false,
            openStarterForm: false,
        };
        this.toogle_request_pop = this.initiatePQ.bind(this);
    }
    componentDidMount() {
        const { pqKey } = this.props;
        if (pqKey === "") {
            this.setState({ IsnullPQKey: true, PQInKey: '' });
        }
        else {
            this.setState({ IsnullPQKey: false, PQInKey: pqKey });
        }
    }
    initiatePQ = () => {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ isInitiatingPayment: true })
        setTimeout(() => {
            this.makepqInvite(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        }, 100)
    }
    makepqInvite(UserId, UserName) {
        try {
            userService.pqInvite(UserId, UserName)
                .then(
                    apidata => {
                        if (apidata.length > 0) {
                            if (apidata[0].code == "1") {
                                this.setState({ IsnullPQKey: false, PQInKey: apidata[0].message });
                                window.open('https://nulifespanrx.mypayquicker.com/Welcome?InvitationId=' + apidata[0].message, '_blank');
                            } else {
                                this.setState({ isInitiatingPayment: false })
                            }
                        }
                    }
                );
        }
        catch (error) {
            this.setState({ isInitiatingPayment: false })
        }
    }
    closeStarterForm = () => {
        this.setState({ openStarterForm: false })
    }
    render() {
        const { pqKey } = this.state.PQInKey;
        //let navlink = 'http://rxhackerpro.mypayquicker.com/Welcome?InvitationId=' + this.state.PQInKey;
        //'https://patientrx.mypayquicker.com/Welcome?InvitationId=' + pqKey;
        let navlink = 'https://nulifespanrx.mypayquicker.com/Welcome?InvitationId=' + this.state.PQInKey;
        //'https://patientrx.mypayquicker.com/Welcome?InvitationId=' + pqKey;
        return (
            <div className="Transactions_Summary payments_box">
                {/* <i className="tooltip"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 16 16" className="triangle-svg"><path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" fill="red" /><path d="M7.1 5.995a.905.905 0 0 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" fill="#1d252d" /><circle cx="8" cy="13" r="1" fill="#1d252d" /></svg><span> We are migrating payment systems over the next 2 months. Please click on "Get Paid" to setup your new payment account.</span></i>*/}
                <div className="contentbox">
                    <h3>Payments</h3>
                    <p>Making payments is easier now!!</p>
                </div>
                <div className="btn-section">
                    {/* {
                        (this.props.pqInviationstatus == 'Completed' || this.props.pqInviationstatus == 'InProgress') && (
                            <>*/}
                                <a href={pdf} className="btns_payment_summary pdf" target="_blank" style={{ marginRight: '0' }}>How it Works</a>
                                {this.state.IsnullPQKey === false ? (
                                    <a href={navlink} className="btns_payment_summary" target="_blank">My Payments <img src={open_url} alt="" /></a>
                                ) : (
                                    <a onClick={this.initiatePQ.bind(this)} className="btns_payment_summary" style={{ pointerEvents: this.state.isInitiatingPayment ? 'none' : 'all', minWidth: this.state.isInitiatingPayment ? 'auto' : '160px' }} target="_blank">{this.state.isInitiatingPayment ? 'Initiating Payment' : <>Initiate Payments <img src={open_url} alt="" /></>}</a>
                                )}
                    {/*//</>
                        //)}
                    <a href="javascript:void(0)" className="btns_payment_summary" onClick={() => this.setState({ openStarterForm: true })}>Get Paid</a>
                    {this.state.openStarterForm ? <W9FormStarter closeStarterForm={this.closeStarterForm} threshold={this.props.threshold} /> : null}*/}
                </div>
            </div>
        )
    }
}
export default Payments_Summary;